export default __webpack_public_path__ + "static/media/1.ef40b7a3.jpg";